var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 1.33333C4.94669 4.36667 3.16669 6.98667 3.16669 9.2C3.16669 12.52 5.70002 14.6667 8.50002 14.6667C11.3 14.6667 13.8334 12.52 13.8334 9.2C13.8334 6.98667 12.0534 4.36667 8.50002 1.33333ZM8.50002 13.3333C6.26669 13.3333 4.50002 11.62 4.50002 9.2C4.50002 7.64 5.80002 5.57333 8.50002 3.10667C11.2 5.57333 12.5 7.63333 12.5 9.2C12.5 11.62 10.7334 13.3333 8.50002 13.3333ZM5.72002 9.33333C5.96669 9.33333 6.16669 9.50667 6.21335 9.74667C6.48669 11.2267 7.73335 11.7333 8.64002 11.66C8.92669 11.6467 9.16669 11.8733 9.16669 12.16C9.16669 12.4267 8.95335 12.6467 8.68669 12.66C7.26669 12.7467 5.60669 11.9333 5.22669 9.91333C5.2151 9.84186 5.21918 9.76872 5.23864 9.69897C5.2581 9.62922 5.29247 9.56454 5.33938 9.50938C5.3863 9.45423 5.44463 9.40992 5.51035 9.37952C5.57607 9.34913 5.64761 9.33337 5.72002 9.33333Z",
    fill: "#DFE7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.3692e4257a1f8c9d5030a21d6c3349c9.svg";
export { ForwardRef as ReactComponent };